import { Spacer, Subtitle } from '@kvdbil/components';
import React from 'react';
import { ServiceContainer } from '~/App/views/ObjectPage/components/BiddingView/components/AdditionalServices';
import { ObjectServiceRecord } from '~/config/generated/graphql';
import HeavyEquipmentService from './HeavyEquipmentService';
import { useObjectPageCMSData } from '~/App/views/ObjectPage/hooks';

const HeavyEquipmentServices = () => {
  const { data: cmsData } = useObjectPageCMSData();

  const services = cmsData?.heavyEquipment?.services;

  return (
    <div>
      <Subtitle style={{ textAlign: 'center' }}>
        {cmsData?.heavyEquipment?.servicesTitle}
      </Subtitle>

      <Spacer height={1.5} />

      {services?.map((service: ObjectServiceRecord, index) => (
        <ServiceContainer key={index}>
          <HeavyEquipmentService service={service} />
        </ServiceContainer>
      ))}
    </div>
  );
};

export default HeavyEquipmentServices;
